// extracted by mini-css-extract-plugin
export default {"mergeSchoolsStep1Container__btnGroup":"MergeSchoolsStep1_mergeSchoolsStep1Container__btnGroup__+9BEA"};